import { LogIn, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function AdminLogin() {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="min-h-[80vh] bg-[#F7F7F8] flex items-center justify-center py-16" data-testid="page-admin-login">
      <Seo title="Admin Sign-in" path="/admin/login" noindex />
      <div className="max-w-md w-full bg-white p-10 border border-gray-100">
        <div className="overline mb-4">Admin</div>
        <h1 className="font-serif text-3xl leading-tight">Sign in to the admin dashboard</h1>
        <p className="mt-4 text-sm text-[#4B5563]">Only authorized team members may access this area. Sign in with the whitelisted Google account.</p>
        <button onClick={login} data-testid="admin-google-signin" className="btn btn-primary w-full justify-center mt-8">
          <LogIn className="w-4 h-4" strokeWidth={1.5} /> Continue with Google
        </button>
        <p className="mt-6 text-xs text-[#6B7280] flex items-center gap-2"><ShieldCheck className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} /> Secure sign-in via Emergent-managed Google Auth.</p>
        <div className="mt-8 border-t border-gray-100 pt-6">
          <Link to="/" className="text-sm text-[#4B5563] hover:text-gold">← Back to website</Link>
        </div>
      </div>
    </div>
  );
}
